import { TaskStatus } from "data/constants";

export type TaskItemType = "SINGLE_LINE" | "MULTIPLE_LINE";

export interface ParticularChangeType {
  index: number;
  key: string;
  value: any;
}

export interface OtherParticularChangeType {
  id?: number;
  index: number;
  key: string;
  value: any;
  taskExpenseType: string;
}

export interface Address {
  displayName: string;
  legalName: string;
  tag: string;
  buildingNumber: string;
  floorNumber: string;
  district: string;
  location: string;
  buildingName: string;
  street: string;
  city: string;
  state: string;
  pincode: string;
  email: string;
  mobileNumber: string;
  billingfulladdress: any;
  countryCode: string;
  gstNumber: string | null;
  panNumber: string | null;
  msmeType?: string | null;
  msmeNumber?: string | null;
}

export interface Particular {
  name: string;
  hsn: string;
  units: number;
  rate: number;
  discountType: "PERCENT" | "AMOUNT";
  discount: number;
  amount: number;
  gst: string | null | {};
  taskId?: number;
  id?: number;
  taskName?: string;
  expectedFee?: number;
  status: TaskStatus;
  additionalFee: number;
  taskNumber: string;
  actualFee: number;
  taskItemType: TaskItemType | null;
  tasks?: any;

}

export interface OtherParticular {
  id?: number;
  name: string;
  amount: number;
  taskExpenseType: string;
}

export interface BankDetails {
  accountNumber: string;
  bankName: string;
  branchName: string;
  ifscCode: string;
  upiId: string;
  accountName: string;
  accountType: string;
  upiAttachment: string;
  upiAttachmentId: string;
}

export interface IState {
  type: "INVOICE" | "PROFORMA";
  billingEntity: number | null;
  locationOfSupply: string;
  proformaLocationOfSupply: string;
  approvalHierarchy: any;
  client: any | string | null;
  clientType: string | null;
  selectedItems: number | null;
  placeOfSupply: string;
  creditNoteNumberType: "AUTO_GENERATED" | "MANUAL";
  autoGeneratedNumber: string;
  creditNoteNumber: string;
  creditNoteDate: string | null;
  terms: string | null;
  billingEntityAddress: Address | null;
  shippingAddress: Address | null;
  billingAddress: Address | null;
  particulars: Array<Particular>;
  otherParticulars: Array<OtherParticular>;
  bankDetails: BankDetails | null;
  signatureUser: number | null;
  termsAndConditionsCopy: Array<string>;
  adjustment: number;
  narration: string;
  showNarration: boolean;
  interState: boolean;
  whatsappCheck: boolean;
  emailCheck: boolean;
  prefix: string;
  crnNumber: string;
  hasGst: boolean;
  showClientData: boolean;
  showDiscount: boolean;
  fromTask: boolean;
  createdAt: string;
  logoUrl: string;
  signatureUrl: string;
  selected: any[];
  proformaId: number | null;
  divideTax: boolean;
  supplyType: "PAYMENT_OF_IGST" | "UNDER_BOND";
  tdsRate: string | null;
  tdsSection: string | null;
  selectedInvoices: Array<number>;
  totalReceivable: number | null;
  hasTds: boolean;
  tdsView: boolean;
  narrationOnPreview: boolean;
  isZohoConnect: boolean;
  showPaymentRecorded: boolean;
  previousIoBalance: boolean;
  msmeNumber: String;
  msmeType: String;

}

export let initialParticular: Particular = {
  name: "",
  hsn: "99",
  units: 1,
  rate: 0,
  discountType: "PERCENT",
  discount: 0,
  amount: 0,
  gst: { desc: "", name: "18%", value: "GST18" },
  status: TaskStatus.TODO,
  additionalFee: 0,
  actualFee: 0,
  expectedFee: 0,
  taskNumber: "",
  taskItemType: null,
  tasks: []
};

export const initialState: IState = {
  signatureUser: null,
  type: "INVOICE",
  createdAt: "",
  hasGst: false,
  showClientData: false,
  showDiscount: false,
  fromTask: false,
  billingEntity: null,
  locationOfSupply: "",
  proformaLocationOfSupply: "",
  billingEntityAddress: null,
  approvalHierarchy: null,
  client: null,
  clientType: null,
  selectedItems: null,
  placeOfSupply: "",
  creditNoteNumberType: "AUTO_GENERATED",
  autoGeneratedNumber: "",
  creditNoteNumber: "",
  creditNoteDate: null,
  terms: null,
  shippingAddress: null,
  billingAddress: null,
  particulars: [],
  otherParticulars: [],
  bankDetails: null,
  termsAndConditionsCopy: [],
  adjustment: 0,
  narration: '',
  showNarration: false,
  interState: false,
  whatsappCheck: false,
  emailCheck: false,
  prefix: "",
  crnNumber: "",
  logoUrl: "",
  signatureUrl: "",
  selected: [],
  selectedInvoices:[],
  totalReceivable: 0,
  proformaId: null,
  divideTax: false,
  supplyType: "PAYMENT_OF_IGST",
  tdsRate: null,
  tdsSection: null,
  hasTds: false,
  tdsView: false,
  narrationOnPreview: false,
  isZohoConnect: false,
  showPaymentRecorded: false,
  previousIoBalance: false,
  msmeNumber: '',
  msmeType: '',
};
